export const FALLBACK_DOC_URL = '/assets/pdf/TopLineAppointmentPrep_JenniferPorter_INTERNAL_ManualJS5';
export const events_server_url = 'http://topline-doc-portal-events-dev.futuridata.futurimedia.com/event';
// export const sp_collector_url = 'https://events.topline-doc-portal.futuridata.futurimedia.com/api/v1/snowplow';
export const sp_collector_url = 'https://collector.futuridata.futurimedia.com';
// Snowplow identifiers
export const SP_ID = 'sp20230509';
export const SP_APP_ID = 'sp20230509-topline-doc-portal';
